<div class="page-container">
  <app-card>
    <app-card-header>
      <app-card-title>{{ 'reports.dailyActivity.title' | translate }}</app-card-title>
    </app-card-header>
    <app-card-content>
      <app-report-filter-bar [includeAllUsers]="includeAllUsers" (filtersChange)="onFiltersChange($event)" />

      @if (loading()) {
        <div class="loading-container flex flex-column flex-align-center p-lg no-print">
          <app-spinner />
        </div>
      } @else if (rows().length === 0) {
        <p class="empty-state" data-testid="daily-activity-empty">{{ 'reports.dailyActivity.empty' | translate }}</p>
      } @else {
        <table class="report-table" data-testid="daily-activity-table">
          <thead>
            <tr>
              <th>{{ 'reports.dailyActivity.user' | translate }}</th>
              <th>{{ 'reports.dailyActivity.doors' | translate }}</th>
              <th>{{ 'reports.dailyActivity.contacts' | translate }}</th>
              <th>{{ 'reports.dailyActivity.contactRate' | translate }}</th>
              <th>{{ 'reports.dailyActivity.leads' | translate }}</th>
              <th>{{ 'reports.dailyActivity.conversionRate' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows(); track row.userId) {
              <tr [attr.data-testid]="'daily-activity-row-' + row.userId">
                <td>{{ row.userName }}</td>
                <td>{{ row.doors }}</td>
                <td>{{ row.contacts }}</td>
                <td>{{ (row.contactRate * 100).toFixed(1) }}%</td>
                <td>{{ row.leads }}</td>
                <td>{{ (row.conversionRate * 100).toFixed(1) }}%</td>
              </tr>
            }
          </tbody>
        </table>
      }
    </app-card-content>
    @if (canExport) {
      <app-card-actions class="no-print">
        <app-button variant="outlined" (click)="exportCsv()" data-testid="export-csv-button">
          <app-icon name="download" [size]="16" />
          {{ 'reports.exportCsv' | translate }}
        </app-button>
        <app-button variant="outlined" (click)="exportXlsx()" data-testid="export-xlsx-button">
          <app-icon name="download" [size]="16" />
          {{ 'reports.exportXlsx' | translate }}
        </app-button>
      </app-card-actions>
    }
  </app-card>
</div>
